export default __webpack_public_path__ + "static/media/lADPGojJ8xw3_bLNBQDNA8A_960_1280.0b265493.jpeg";